/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const FarmCreatePage = lazyLoad(
  () => import('./index'),
  module => module.FarmCreatePage
);
